import prestashop from 'prestashop';
import $ from 'jquery';

prestashop.tsoSelectors = {
  touchspin: '.js-touchspin',
  modalContent: '.js-tso-modal-content',
  modal: '#modal, .js-tso-checkout-modal',
  address: {
    termsLink: '.js-tso-terms a',
  },
  cart: {
    productLineQty: '.js-tso-cart-line-product-quantity',
    detailedTotalsBottom: '.js-tso-cart-detailed-totals-bottom',
    voucher: '.js-tso-cart-voucher',
    overview: '.js-tso-cart',
    rightSummary: '.js-tso-checkout-summary',
    lineProductQuantity: '.js-tso-cart-line-product-quantity',
  },
  deliveryPayments: {
    countryCarrierSelect: 'select#delivery_id_country',
    deliveryInput: 'input.delivery_option_radio',
    paymentInput: 'input.payment_option_radio',
    btnCartNavigation: '.cart_navigation a.btn',
    paymentLoader: '#payments-content .loader',
    deliveryLoader: '#carriers-content .loader',
    addressLoader: '#addressess-content .loader',
    carriersList: '#carriers-data',
    paymentsList: '#payments-data',
    hookTopPayment: '#HOOK_TOP_PAYMENT',
  },
};

$(document).ready(() => {
  prestashop.emit('tsoSelectorsInit');
});
